import { PageFooter, PageHeader } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useManageAddEmployeesPageStore } from 'store/pages/enrollment/manage-add-employees/pageStore';
import { TableManagementPanel } from './TableManagementPanel';
import { AddEmployeesTable } from '../../common/enrollment/add-employees/AddEmployeesTable';

// TESTING_POLICY: CYPRESS_ONLY

export const PageContent: React.FC = observer(() => {
  const pageStore = useManageAddEmployeesPageStore();
  const { onBack } = pageStore;

  return (
    <>
      <PageHeader
        title="Manage Add Employees"
        subtitle="Manage and monitor employees added to the census"
        subtitleMaxWidth="42rem"
        onBackButtonClick={onBack}
      />
      <TableManagementPanel />
      <AddEmployeesTable pageStore={pageStore} />
      <PageFooter onBack={onBack} />
    </>
  );
});
